// extracted by mini-css-extract-plugin
export var standaloneTable = "_hp-0";
export var standaloneTableWithBodyFill = "_hp-1";
export var withExtraHeader = "_hp-2";